export default "__VITE_ASSET__CsbVLUux__"